export default angular.module('relationshipRule', [])
  .directive('relationshipRule', function () {
    return {
      restrict: "A",
      require: 'ngModel',
      link: function ($scope, $elem, $attr, $ngModelController) {
        $ngModelController.$validators.duplicate = function (modelValue) {
          return !(modelValue.error && modelValue.error.duplicate);
        };

        $ngModelController.$validators.conflict = function (modelValue) {
          return !(modelValue.error && modelValue.error.conflict);
        };

        $ngModelController.$validators.unresolvable = function (modelValue) {
          return !(modelValue.error && modelValue.error.unresolvable);
        };
      },
    };
  })
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/relationshipRule.directive.js
 **/